import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterHorarios'
})
export class FilterHorariosPipe implements PipeTransform {

  transform(value: any[], searchText: string): any[] {
    if (!value || !searchText) return value;

    const lower = searchText.toLowerCase();

    return value.filter(hr => {
      const fields = ['sDesLargo01', 'sCodigo02', 'sCodigo03', 'sCodigo04', 'sCodigo05', 'sDesCorto04', 'sDesCorto05'];
      return fields.some(key => hr[key]?.toLowerCase().includes(lower));
    });
  }
}
